import { Row, Col, Button, Input, Form, notification, Switch } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../utils/config.js";

import "./Settings.css";
import "react-quill/dist/quill.snow.css";
import endpoints from "../../utils/endpoints.js";
import APEDTlogo from "../../assets/images/APEDT-grey-logo.svg";
import SPNlogo from "../../assets/images/SPN-grey-logo.svg";

function SettingsAHASlides({ data }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data.length > 0) {
      let ahaSlidesData = data.filter((item) => item.name === "aha_slides")[0];
      let auxValues = JSON.parse(ahaSlidesData.json);
      console.log({ spn_link: auxValues.spn.link, is_active: auxValues.spn.is_active, apedt_link: auxValues.apedt.link, apedt_is_active: auxValues.apedt.is_active });
      form.setFieldsValue({ spn_link: auxValues.spn.link, spn_is_active: auxValues.spn.is_active, apedt_link: auxValues.apedt.link, apedt_is_active: auxValues.apedt.is_active });
    }
  }, [data]);

  function handleSubmit(values) {
    setIsButtonLoading(true);

    const auxValues = {
      spn: { link: values.spn_link, is_active: values.spn_is_active },
      apedt: { link: values.apedt_link, is_active: values.apedt_is_active },
    };

    axios
      .post(endpoints.settings.update, {
        data: { values: auxValues, name: "aha_slides" },
      })
      .then((resData) => {
        setIsButtonLoading(false);
        notification.success({
          message: "Success!",
          description: "Definições foram editadas com sucesso!",
        });
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        notification.error({
          message: "Oops!",
          description: "Algo de errado aconteceu! Tente novamente mais tarde.",
        });
      });
  }

  function handleWarningMissingFields() {
    notification.error({
      message: `Campos por preencher`,
      description: "Faltam alguns campos para preencher!",
    });
  }

  return (
    <div className="dashboard_page">
      <Row className="dashboard_content_row">
        <Col span={24}>
          <Form form={form} id="add-commission_type-form" layout="vertical" onFinish={handleSubmit} onFinishFailed={handleWarningMissingFields}>
            <Form.Item hidden name="id">
              <Input />
            </Form.Item>
            <Row gutter={[24]}>
              <Col span={12}>
                <img src={SPNlogo} />
                <Form.Item name="spn_is_active" label="Ativo" valuePropName="checked">
                  <Switch size="large" />
                </Form.Item>
                <Form.Item label="Link" name={"spn_link"}>
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <img src={APEDTlogo} />
                <Form.Item name="apedt_is_active" label="Ativo" valuePropName="checked">
                  <Switch size="large" />
                </Form.Item>
                <Form.Item label="Link" name={"apedt_link"}>
                  <Input size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item noStyle>
              <Button type="primary" size="large" onClick={form.submit} loading={isButtonLoading}>
                Save
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default SettingsAHASlides;
